import { useId } from 'react';
import { Grid } from '../../grid';
import { VisuallyHidden } from '../../visually-hidden';
import { Cell, flexRender, Header } from '@tanstack/react-table';
import { Box } from '../../box';
import { TableProps } from '../types';

interface Props<T> {
  cell: Cell<T, unknown>;
  size: TableProps<T>['size'];
  customCellStyles?: TableProps<T>['customCellStyles'];
  headers: Header<T, unknown>[];
  index: number;
}

export const ListTableCell = <T,>({
  cell,
  size,
  customCellStyles,
  headers,
  index,
}: Props<T>) => {
  const id = useId();

  return (
    <Grid
      key={cell.id}
      gap={size === 'normal' ? 2 : 0}
      {...(customCellStyles ? { customCellStyles } : {})}
    >
      <VisuallyHidden id={id}>
        {flexRender(cell.column.columnDef.header, headers[index].getContext())}
      </VisuallyHidden>

      <Box aria-labelledby={id}>
        {flexRender(cell.column.columnDef.cell, cell.getContext())}
      </Box>
    </Grid>
  );
};
